// initial state
import * as base from './base.js'
const baseName = '/admin/api/about'

const obj = base.setBaseUrl('regard', baseName)

const a = Object.assign(obj, {})
export default a
